export default __webpack_public_path__ + "resources/docs/3.budgeting_tips_compressed.4d768d77.pdf";